import React from "react";
import { useEffect, useRef, useState } from "react";
import styles from "../../Header.module.scss";
import SubMenuColumn from "../SubMenuColumn";
import { useSelector } from "react-redux";
export function SubMenu({ subMenu, navigationTitle }) {
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const submenuToggle=useSelector( 
    (state) => state.header.isSubmenuVisible //state to check when the submenu should be shown
  );
  var countOfPortraitTile = 0;
  let subMenuColumnss = subMenu?.map((menu, index) => {
    if(menu?.imageLink){
      countOfPortraitTile++;
    }
    return (
      <SubMenuColumn
        key={index}
        columns={menu}
        countOfPortraitTile={countOfPortraitTile}
        navigationTitle = {navigationTitle}
      />
    );
  });
  return (
    <section className={`bg-oat mw-1440 ${submenuToggle && styles.display}  ${styles.sub_menu_section} ${isPWA && styles.pwa_submenu_section}`}>
      <div className={`${styles.column_wrapper} ${isPWA && styles.pwa_column_wrapper}`}>{subMenuColumnss}</div>
    </section>
  );
}
export default SubMenu;
